export default "__VITE_ASSET__26W7auNF__"